document.addEventListener("DOMContentLoaded", function () {
  const MultipleSlider = () => {
    const MultipleSliders = document.querySelectorAll(".catgsliderSlider");

    MultipleSliders.forEach((slider) => {
      const pagin = slider.parentElement.querySelector(".swiper-pagination");
      const prevArrow = slider.parentElement.querySelector(".prev");
      const nextArrow = slider.parentElement.querySelector(".next");

      const isDesktop = window.innerWidth >= 1025;

      new Swiper(slider, {
        direction: "horizontal",
        speed: 1000,

        loop: isDesktop,

        autoplay: isDesktop
          ? {
              delay: 3000,
              disableOnInteraction: false,
            }
          : false,

        navigation: {
          nextEl: nextArrow,
          prevEl: prevArrow,
        },

        pagination: {
          el: pagin,
          clickable: true,
        },

        breakpoints: {
          150: {
            slidesPerView: 1.3,
            spaceBetween: 10,
          },
          576: {
            slidesPerView: 2.3,
            spaceBetween: 15,
          },
          769: {
            slidesPerView: 2.1,
            spaceBetween: 15,
          },
          1025: {
            slidesPerView: 2.2,
            spaceBetween: 20,
          },
        },
      });
    });
  };

  MultipleSlider();
});

{
  document.addEventListener("DOMContentLoaded", function () {

    const row1 = document.querySelector(".clientTestRow.forward");
    if (row1) {
      const boxes1 = Array.from(row1.querySelectorAll(".clientTestiBox"));
      const CLONE_COUNT = 3;

      for (let i = 0; i < CLONE_COUNT; i++) {
        boxes1.forEach(box => row1.appendChild(box.cloneNode(true)));
      }

      const distance1 = row1.scrollWidth / 2;
      const duration1 = distance1 / 70;

      const anim1 = gsap.to(row1, {
        x: -distance1,
        duration: duration1,
        ease: "none",
        repeat: -1
      });

      row1.addEventListener("mouseenter", () => anim1.pause());
      row1.addEventListener("mouseleave", () => anim1.resume());
    }

    const row2 = document.querySelector(".clientTestRow.revers");
    if (row2) {
      const boxes2 = Array.from(row2.querySelectorAll(".clientTestiBox"));
      const CLONE_COUNT = 3;

      for (let i = 0; i < CLONE_COUNT; i++) {
        boxes2.forEach(box => row2.appendChild(box.cloneNode(true)));
      }

      const distance2 = row2.scrollWidth / 2;
      const duration2 = distance2 / 70;

      const anim2 = gsap.fromTo(row2,
        { x: -distance2 },
        { x: 0, duration: duration2, ease: "none", repeat: -1 }
      );

      row2.addEventListener("mouseenter", () => anim2.pause());
      row2.addEventListener("mouseleave", () => anim2.resume());
    }
  });
}{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".pdp_slides");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          // loop: true,
          speed: 1000,
          //   autoplay: {
          //     delay: 1000,
          //     disableOnInteraction: false,
          //   },
          grabCursor: true,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 1.5,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 2.5,
              spaceBetween: 10,
            },
            769: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            1025: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}
{
  document.addEventListener("DOMContentLoaded", function () {
    const MultipleSlider = () => {
      const MultipleSliders = document.querySelectorAll(".Blogs_slides");
      MultipleSliders.forEach((slider, index) => {
        const prevArrow = slider.parentElement.querySelector(".prev");
        const nextArrow = slider.parentElement.querySelector(".next");
        new Swiper(slider, {
          direction: "horizontal",
          // loop: true,
          speed: 1000,
          //   autoplay: {
          //     delay: 1000,
          //     disableOnInteraction: false,
          //   },
          grabCursor: true,
          navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
          },
          breakpoints: {
            150: {
              slidesPerView: 1.3,
              spaceBetween: 10,
            },
            576: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
            769: {
              slidesPerView: 2.6,
              spaceBetween: 10,
            },
            1025: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1200: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
          },
        });
      });
    };
    MultipleSlider();
  });
}
